const CartModal = () => import('./CartModal')
const SimpleProductCard = () => import('./SimpleProductCard')

export default function install(Vue) {
  Vue.component('CartModal', CartModal)
  Vue.component('SimpleProductCard', SimpleProductCard)
}
